import * as React from "react";
import classNames from "classnames";
import { useSnapshot } from "valtio";
import { Placeholder } from "./Placeholder";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { letterStore } from "src/js/stores/letter/store";

interface SignatureProps {
  showValues?: boolean;
}

export const Signature: React.FC<SignatureProps> = ({ showValues }) => {
  const {
    letter: { signOff, contactName, contactEmail, contactPhone, signature },
  } = useSnapshot(letterStore);
  const { t } = useTranslation();

  return (
    <div>
      <div className={classNames("mt-8")} data-testid="letter-preview-signoff">
        {signOff}
      </div>

      <div data-testid="letter-preview-signature">
        {showValues || signature?.url ? (
          <div
            className={classNames(
              "flex",
              "items-center",
              "justify-center",
              "h-[94px]",
              "w-[156px]",
              "my-2",
              "bg-contain",
              "overflow-hidden",
              !signature?.url && "hidden"
            )}
          >
            <img className={classNames("h-auto", "w-full", "object-center")} src={signature?.url} />
          </div>
        ) : (
          <Placeholder className={classNames("h-[94px]", "w-[156px]", "my-1")}>
            <div className={classNames("flex", "flex-col", "items-center", "justify-center")}>
              <i className="icon-lt-image-line text-3xl text-neutral-400" />
              {t("sites.letters.signature")}
            </div>
          </Placeholder>
        )}
      </div>

      <div className={classNames("mt-1")} data-testid="letter-preview-signature-contact">
        <span>{contactName}</span>
        <br />
        <span>{contactEmail}</span>
        <br />
        <span>{contactPhone}</span>
      </div>
    </div>
  );
};
